/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Background_Settings_TitleInputs */



/**
* | output |
* | --- |
* | "Background Settings" |
*
* @param {Image_Export_Background_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_background_settings_title = /** @type {((inputs?: Image_Export_Background_Settings_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Background_Settings_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Parametres d'arriere-plan")
	if (locale === "de") return /** @type {LocalizedString} */ ("Hintergrundeinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni di sfondo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки фона")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de fondo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("背景设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("背景設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पृष्ठभूमि सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações de fundo")
	return /** @type {LocalizedString} */ ("Background Settings")
});